import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const ACCESS_PIN = '412100';
const ACCESS_DURATION = 60 * 60 * 1000; // 1 hour
const STORAGE_KEY = 'app_access_expiry';

function PinGate() {
  const [pin, setPin] = useState('');
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const expiry = localStorage.getItem(STORAGE_KEY);

    if (expiry && Date.now() < Number(expiry)) {
      setIsAuthorized(true);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (pin === ACCESS_PIN) {
      const expiryTime = Date.now() + ACCESS_DURATION;

      localStorage.setItem(STORAGE_KEY, expiryTime.toString());

      setIsAuthorized(true);
      setError('');
    } else {
      setError('Invalid PIN. Please try again.');
      setPin('');
    }
  };

  if (isAuthorized) {
    return <App />;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f5f5',
        padding: '20px',
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          width: '100%',
          maxWidth: '360px',
          background: '#fff',
          padding: '30px',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
        }}
      >
        <h2 style={{ marginBottom: '10px' }}>Enter PIN</h2>

        <p
          style={{
            marginBottom: '20px',
            color: '#666',
            fontSize: '14px',
          }}
        >
          Enter the PIN to continue
        </p>

     <input
  type="password"
  value={pin}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, '');
    setPin(value);
  }}
  placeholder="Enter PIN"
  maxLength={6}
  inputMode="numeric"
  pattern="[0-9]*"
  autoFocus
  style={{
    width: '100%',
    boxSizing: 'border-box',
    padding: '12px',
    fontSize: '18px',
    textAlign: 'center',
    letterSpacing: '5px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    outline: 'none',
  }}
/>

        {error && (
          <p
            style={{
              color: '#d32f2f',
              fontSize: '14px',
              marginTop: '10px',
            }}
          >
            {error}
          </p>
        )}

        <button
          type="submit"
          style={{
            width: '100%',
            marginTop: '20px',
            padding: '12px',
            border: 'none',
            borderRadius: '8px',
            background: '#1976d2',
            color: '#fff',
            fontSize: '16px',
            cursor: 'pointer',
          }}
        >
          Continue
        </button>
      </form>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PinGate />
  </React.StrictMode>
);

reportWebVitals();